"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What exactly is canine bodywork and massage?",
  answer: "It is a professional, clinical approach to manual therapy designed to improve your dog's mobility, reduce pain, and support recovery. Much like human physical therapy, we focus on soft tissue health to enhance overall performance and long-term musculoskeletal comfort."
}, {
  question: "Is this beneficial for dogs that aren't highly active?",
  answer: "Absolutely. While we specialize in post-hike recovery for mountain dogs, bodywork is vital for senior dogs managing age-related stiffness or pets recovering from surgery. It provides significant relief and improves quality of life for dogs at any activity level."
}, {
  question: "Do you provide services in-home or at a clinic?",
  answer: "We offer the flexibility of in-home visits throughout the Durango area to ensure your dog is in their most comfortable environment. We also have appointments available at our professional shared clinical space for those who prefer a clinical setting."
}, {
  question: "How is this different from a pet spa treatment?",
  answer: "Our approach is 'Mountain Clinical.' While the sessions are deeply relaxing, the primary goal is therapeutic. We use evidence-based techniques to address specific musculoskeletal issues, support athletic performance, and manage chronic conditions with professional competence."
}, {
  question: "What should I expect during my dog's first session?",
  answer: "We begin with a thorough assessment of your dog’s movement and history. The session is guided by your dog’s comfort level, using gentle but effective techniques to release tension. We will also discuss a personalized plan for ongoing support and mobility maintenance."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222948" id="common-inquiries" className="w-full py-16 md:py-24 lg:py-32 bg-background text-foreground">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-normal">
            Common Inquiries
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Find answers to common questions about our canine bodywork, mobility support, and professional care.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-lg bg-background/50 backdrop-blur-sm overflow-hidden transition-colors data-[state=open]:border-secondary/50 data-[state=open]:shadow-md">
              <AccordionTrigger className="text-xl font-bold font-default hover:no-underline hover:bg-muted/20 px-6 py-5 transition-colors text-foreground data-[state=open]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base font-normal font-default text-muted-foreground px-6 pb-6 pt-2 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}